import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import {
  BaseEnumerableResponse,
  ProductDetailDTO,
  ProductSubType,
  ProductType,
  Request,
} from "@campgladiator/cg-common.types.types";
import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";

type FetchProductDetailsType = {
  productType?: ProductType;
  productSubType?: ProductSubType;
};

const buildProductDetailsFetching = async ({
  productType,
  productSubType,
}: FetchProductDetailsType) => {
  const endpoint = "/library/v1/product-details";
  const method = "GET";
  const params = `?type=${productType ?? ""}&subType=${productSubType ?? ""}`;
  const request: Request = {
    requestConfig: {
      method,
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint,
        params,
      },
    },
  };
  const response = await fetchRequest({ request });
  const result = await response.json();
  return {
    response,
    result,
  };
};

export const fetchProductDetails = async ({
  productType,
  productSubType,
}: FetchProductDetailsType): Promise<ProductDetailDTO> => {
  try {
    const { response, result } = await buildProductDetailsFetching({
      productType,
      productSubType,
    });

    return response.ok
      ? (result.content[0] as ProductDetailDTO)
      : Promise.reject(new Error(result.error));
  } catch (error) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || "An unknown error occurred";

    throw new Error(errorMessage as string);
  }
};

export const fetchAllProductDetails = async ({
  productType,
  productSubType,
}: FetchProductDetailsType): Promise<ProductDetailDTO[]> => {
  try {
    const { response, result } = await buildProductDetailsFetching({
      productType,
      productSubType,
    });

    return response.ok
      ? result.content
      : Promise.reject(new Error(result.error));
  } catch (error) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || "An unknown error occurred";

    throw new Error(errorMessage as string);
  }
};
